import React, { useState } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';

const NAV = [
  { to: '/dashboard',  icon: '📊', label: 'Přehled' },
  { to: '/orders',     icon: '📦', label: 'Objednávky' },
  { to: '/packing',    icon: '📫', label: 'Balírna' },
  { to: '/shipping',   icon: '🚚', label: 'Expedice' },
  { to: '/products',   icon: '🛍️',  label: 'Produkty' },
  { to: '/warehouse',  icon: '🏭', label: 'Sklad' },
  { to: '/invoices',   icon: '📄', label: 'Faktury' },
  { to: '/payments',   icon: '💳', label: 'Platby' },
  { to: '/facebook',   icon: '📣', label: 'Facebook' },
  { to: '/customers',  icon: '👥', label: 'Zákazníci' },
  { to: '/reports',    icon: '📈', label: 'Přehledy' },
  { to: '/settings',   icon: '⚙️',  label: 'Nastavení' },
];

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={{
        width: 220,
        background: '#0d3a6e',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        position: 'fixed',
        top: 0, left: 0, bottom: 0,
        zIndex: 100,
        transform: sidebarOpen || window.innerWidth > 768 ? 'none' : 'translateX(-100%)',
        transition: 'transform 0.2s',
      }}>
        <div style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ background: 'white', padding: '10px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src="/logo.png"
              alt="P.S.I. Direct"
              style={{ width: '100%', maxWidth: 190, display: 'block' }}
            />
          </div>
          <div style={{ padding: '8px 12px 10px' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: 'white', lineHeight: 1.3 }}>P.S.I. prodejna pro Facebook</div>
          </div>
        </div>
        <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
          {NAV.map(({ to, icon, label }) => (
            <NavLink key={to} to={to} onClick={() => setSidebarOpen(false)}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 16px',
                color: isActive ? 'white' : 'rgba(255,255,255,0.65)',
                background: isActive ? 'rgba(255,255,255,0.12)' : 'transparent',
                borderLeft: isActive ? '3px solid #4da6ff' : '3px solid transparent',
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: isActive ? 600 : 400,
                transition: 'all 0.15s',
              })}>
              <span style={{ fontSize: 16, width: 20, textAlign: 'center' }}>{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.1)', fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>
          P.S.I. prodejna pro Facebook v1.0
        </div>
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99,
        }} />
      )}

      {/* Main content */}
      <div style={{ flex: 1, marginLeft: 220, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* Top bar */}
        <header style={{
          background: '#185FA5', color: 'white',
          padding: '0 20px', height: 52,
          display: 'flex', alignItems: 'center', gap: 12,
          position: 'sticky', top: 0, zIndex: 50,
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        }}>
          <button onClick={() => setSidebarOpen(o => !o)}
            style={{ background: 'none', border: 'none', color: 'white', fontSize: 20, cursor: 'pointer', display: 'none' }}
            className="mobile-menu-btn">
            ☰
          </button>
          <div style={{ flex: 1 }} />
          <span style={{ fontSize: 13, opacity: 0.8 }}>
            {new Date().toLocaleDateString('cs-CZ', { weekday: 'short', day: 'numeric', month: 'long' })}
          </span>
        </header>

        {/* Page content */}
        <main style={{ flex: 1, padding: '24px 20px', maxWidth: 1400, width: '100%', margin: '0 auto' }}>
          <Outlet />
        </main>
      </div>

      <style>{`
        @media (max-width: 768px) {
          aside { transform: translateX(-100%) !important; }
          aside.open { transform: none !important; }
          .main-content { margin-left: 0 !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </div>
  );
}
